import { Link } from 'react-router-dom';

const reasons = [
  {
    icon: 'ri-graduation-cap-fill',
    title: 'Degree-Backed Expertise',
    desc: 'Our owner holds a formal degree in landscaping — every project is personally overseen to the highest professional standard, ensuring execution that goes far beyond industry norms.',
  },
  {
    icon: 'ri-shield-check-fill',
    title: 'Premium Materials, Always',
    desc: 'We source only the finest materials for every fence, paver, and landscape project — built specifically to endure Florida\'s heat, humidity, and seasonal storms.',
  },
  {
    icon: 'ri-customer-service-2-fill',
    title: 'White-Glove Communication',
    desc: 'You\'ll always know what\'s happening. From first contact to final walk-through, we communicate clearly, stay on schedule, and treat your property with respect.',
  },
  {
    icon: 'ri-map-pin-2-fill',
    title: 'Deep Florida Roots',
    desc: 'We\'ve served Volusia and Flagler County communities for years. We understand Florida soil, codes, and HOA requirements — giving you seamless, compliant results every time.',
  },
];

const stats = [
  { value: '5★', label: 'Google Rating' },
  { value: '6+', label: 'Cities Served' },
  { value: '100%', label: 'Satisfaction Rate' },
  { value: '5', label: 'Services Offered' },
];

export default function WhyChooseUs() {
  return (
    <section className="bg-stone py-28 px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">

          {/* Left: Image collage */}
          <div className="relative order-2 lg:order-1">
            {/* Main image */}
            <div className="relative w-full h-[580px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/b3084859150cfc815fb10aa86005f8ad.jpg"
                alt="Dippel's Outdoor Services — craftsmanship Florida"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/30"></div>
            </div>

            {/* Stacked secondary image */}
            <div className="absolute -right-5 top-8 w-44 h-56 rounded-xl overflow-hidden border-4 border-white shadow-xl hidden lg:block">
              <img
                src="https://readdy.ai/api/search-image?query=luxury%20paver%20patio%20detail%20close-up%20premium%20natural%20stone%20craftsmanship%20Florida%20elegant%20outdoor%20installation%20high-end%20result&width=350&height=450&seq=dippels-why-sec&orientation=portrait"
                alt="Premium paver craftsmanship — Dippel's Florida"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Stats overlay card */}
            <div className="absolute -bottom-5 -left-5 bg-charcoal text-white rounded-2xl p-6 grid grid-cols-2 gap-x-8 gap-y-4">
              {stats.map((s, i) => (
                <div key={i}>
                  <p className="font-serif text-gold text-2xl font-bold leading-none mb-0.5">{s.value}</p>
                  <p className="text-white/50 text-xs">{s.label}</p>
                </div>
              ))}
            </div>

            {/* Decorative circle */}
            <div className="absolute -top-6 -left-6 w-28 h-28 bg-gold/8 rounded-full -z-10"></div>
          </div>

          {/* Right: Content */}
          <div className="order-1 lg:order-2">
            <p className="text-gold font-sans text-[11px] font-semibold tracking-[0.28em] uppercase mb-5 flex items-center gap-3">
              <span className="h-px w-8 bg-gold inline-block"></span>
              Why Dippel's
            </p>
            <h2 className="font-serif text-charcoal font-bold leading-tight mb-6" style={{ fontSize: 'clamp(32px, 3.2vw, 48px)' }}>
              Craftsmanship That Sets<br />
              <em className="not-italic text-forest">a New Standard</em>
            </h2>
            <p className="text-charcoal-muted text-base leading-relaxed mb-10">
              When you hire Dippel's Outdoor Services, you're not hiring a contractor — you're partnering with specialists who treat your property as if it were their own. Formal training, premium materials, and genuine pride in every project.
            </p>

            <div className="space-y-7 mb-12">
              {reasons.map((r, i) => (
                <div key={i} className="flex gap-5">
                  <div className="w-12 h-12 flex items-center justify-center bg-forest/10 rounded-xl flex-shrink-0">
                    <i className={`${r.icon} text-forest text-lg`}></i>
                  </div>
                  <div>
                    <h4 className="font-serif text-charcoal text-lg font-semibold mb-1.5">{r.title}</h4>
                    <p className="text-charcoal-muted text-sm leading-relaxed">{r.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 bg-charcoal text-white font-semibold px-8 py-4 rounded-full hover:bg-forest transition-colors whitespace-nowrap"
              >
                Schedule Your Consultation
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center justify-center gap-2 border border-charcoal/20 text-charcoal font-semibold px-8 py-4 rounded-full hover:bg-white hover:border-charcoal/40 transition-colors whitespace-nowrap"
              >
                Meet the Team <i className="ri-arrow-right-line text-sm"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
